import { __rest } from "tslib";
import { assoc } from 'ramda';
import { formatRecsModelId } from './recs-model.utils';
export function parseGetRecsModelsResponse(_a) {
    var { size } = _a, data = __rest(_a, ["size"]);
    return (Object.assign(Object.assign({}, data), { perPage: size, items: data.items.map((item) => assoc('name', formatRecsModelId(item.name), item)) }));
}
